import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { ApiRoutesReturns } from "../../constants";
import { Return } from "../../returns.types";

export const requestGetReturns = async (
  params: GetListRequestParams
): Promise<GetListResponse<Return>> => {
  return await instance.get(ApiRoutesReturns.AllReturns, { params });
};
